import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import auth from "./auth";
import Clients from "@/store/Clients";
import Portals from "@/store/Portals";
import Locations from "@/store/Locations";
import Lessons from "@/store/Lessons";
import LessonsCategories from "@/store/LessonsCategories";
import Regions from "@/store/Regions";
import Products from "@/store/Products"

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState({
        key: 'imob_admin',
        paths: ['auth']
    })],
    state: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
        Clients,
        Portals,
        Locations,
        Lessons,
        LessonsCategories,
        Regions,
        Products
    }
})
